import { useEffect } from 'react';

import { useGetEventsForScenario } from '../queries/useGetEventsForScenario';

export const useScenarioEvents = (scenarioId: string, workspaceId: string) => {
  const {
    refetch: fetchEvents,
    hasNextPage,
    data,
    fetchNextPage,
  } = useGetEventsForScenario(workspaceId, scenarioId);

  useEffect(() => {
    if (!hasNextPage) return;

    fetchNextPage();
  }, [hasNextPage, data]);

  return {
    fetchEvents,
    data:
      !hasNextPage && data
        ? data.pages.map((page) => page.content || []).flat()
        : [],
  };
};
